export const mapStateToProps = ({
  reports: {
    deletingReport,
    downloadingReport,
    deleted: reportDeleted,
    created: reportCreated,
    downloaded: reportDownloaded,
  },
}) => ({
  reportDeleted,
  reportCreated,
  deletingReport,
  reportDownloaded,
  downloadingReport,
})

export const handlers = (EVENTS) => ({
  createReportTemplate:
    ({ trackEvent }) =>
    () => {
      const { name } = EVENTS.CREATE_REPORT_TEMPLATE
      trackEvent(name)
    },
  deleteReport:
    ({ trackEvent, deletingReport: { name: reportName } }) =>
    () => {
      const { name } = EVENTS.DELETE_REPORT
      trackEvent(name, { name: reportName })
    },
})

export const onComponentDidUpdate = (prevProps, props) => {
  const { reportCreated, reportDeleted, reportDownloaded } = props
  if (reportCreated !== prevProps.reportCreated && reportCreated) {
    props.createReportTemplate()
  }

  if (reportDownloaded !== prevProps.reportDownloaded && reportDownloaded) {
    props.downloadReport()
  }

  if (reportDeleted !== prevProps.reportDeleted && reportDeleted) {
    props.deleteReport()
  }
}
